import EventDialogHtml from "./EventDialogHtml.js";

export default class EventDialogCmp {
    /** @type {EventDialogHtml}  */
    #html = new EventDialogHtml();

    /** @param {MoleculeEvent} mEvent */
    show(mEvent) {
        this.#html.show(mEvent)
    }

    remove() {
        this.#html.remove()
    }
}